import React from 'react';
import { Card, Radio, Space, Typography } from 'antd';
import { OPERATIONS, PRIMARY_COLOR } from '../upload.constants';
import { Operation, UploadType } from '../upload.types';

const { Text } = Typography;

interface OperationSelectionProps {
  selectedOperation: Operation;
  setSelectedOperation: (operation: Operation) => void;
}

const OperationSelection: React.FC<OperationSelectionProps> = ({ selectedOperation, setSelectedOperation }) => {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto' }}>
      <Typography.Title level={4}>Choisissez le type d&apos;opération</Typography.Title>
      <Space direction="vertical" style={{ width: '100%', marginTop: 20 }}>
        <Radio.Group onChange={e => setSelectedOperation(OPERATIONS.find(op => op.label === e.target.value))} style={{ width: '100%' }}>
          <Space direction="vertical" style={{ width: '100%' }}>
            {OPERATIONS.map(op => (
              <Card key={op.label} style={{ marginBottom: 16, borderColor: PRIMARY_COLOR }}>
                <Radio value={op.label} disabled={op.label === UploadType.REINSCRIPTION}>
                  <Space direction="vertical">
                    <Text strong>{op.label}</Text>
                    <Text type="secondary">{op.description}</Text>
                  </Space>
                </Radio>
              </Card>
            ))}
          </Space>
        </Radio.Group>
      </Space>
    </div>
  );
};

export default OperationSelection;
